module.exports = __webpack_public_path__ + "static/ulf_main-b72d3567307c8e0b9f1f4befbc01bab3.jpg";